<script>
  import Chart from 'chart.js/auto';
  import { onMount } from 'svelte';

  export let config;
  let ctx;
  let chartCanvas;
  let defaultColors = [
    '#F64740',
    '#0C01A3',
    '#EFCB39',
    '#52B4A1',
    '#EF465A',
    '#FC8865',
    '#A4D32E',
    '#7537F2',
    '#5EC0ED',
    '#25BA60',
    '#FED298',
    '#22569B',
    '#027F79',
    '#CF9D06',
  ];
  let colorIndex = 0;
  onMount(async (promise) => {
    ctx = chartCanvas.getContext('2d');
    config.options.maintainAspectRatio = false;
    for (let d of config.data.datasets) {
      d.backgroundColor = defaultColors[colorIndex];
      d.borderColor = defaultColors[colorIndex];
      colorIndex++;
    }
    let chart = new Chart(ctx, config);
  });
</script>

<canvas bind:this={chartCanvas} id="myChart" />
